exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".addNewCardPage-pageContent {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background-color: 'transparent';\n  padding: 3vh 1vh; }\n\n.addNewCardPage--colorinputSection {\n  width: 40%;\n  padding: 2%;\n  background-color: var(--box-background);\n  box-shadow: 0 1px 2px 0 var(--box-shadow-color);\n  border-radius: 5px; }\n\n@media screen and (max-width: 960px) {\n  .addNewCardPage--colorinputSection {\n    width: '80%'; } }\n\n.inputSection {\n  background-color: #ffffff; }\n", ""]);

// exports
